import gql from 'graphql-tag'

export const userFragment = gql`
    fragment userFragment on User{
        id
        name
        email
        must_change_password
        created_at
        updated_at
    }
`